import React, {useEffect, useRef} from "react";
import { QRCodeSVG } from "qrcode.react";
import JsBarcode from 'jsbarcode';

interface BarcodeProps {
  value: string;
  className?: string;
}

export const Barcode: React.FC<BarcodeProps> = ({ value, className }) => {
  const svgRef = useRef<SVGSVGElement | null>(null);

  useEffect(() => {
    if (svgRef.current && value != null) {
      JsBarcode(svgRef.current, value, {
        format: 'CODE128',
        width: 2,
        height: 60,
        displayValue: true,
      });
    }
  }, [value]);

  return <svg ref={svgRef} className={className}></svg>;
};


export const QrCode = ({ value }) => {
  return (
    <QRCodeSVG
      value={value}
      size={180}
      level="M"   
      includeMargin={true}
    />
  );
};


